import { Outlet } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import Footer from './Footer'
import HeaderTop from './HeaderTop'
import CategoryNav from './CategoryNav'
import BackToTopButton from '../../../components/BackToTop'
import MobileBottomBar from './MobileBottomBar'

const Layout = () => {
  const [mobileCategoriesOpen, setMobileCategoriesOpen] = useState(false)
  const headerRef = useRef(null)

  useEffect(() => {
    const updateHeaderOffset = () => {
      const el = headerRef.current
      if (!el) return
      const h = Math.ceil(el.getBoundingClientRect().height)
      document.documentElement.style.setProperty("--ch-header-offset", `${h}px`)
    }

    updateHeaderOffset()

    let ro = null
    if (typeof ResizeObserver === "function" && headerRef.current) {
      ro = new ResizeObserver(() => updateHeaderOffset())
      ro.observe(headerRef.current)
    }

    window.addEventListener("resize", updateHeaderOffset)

    return () => {
      if (ro) ro.disconnect()
      window.removeEventListener("resize", updateHeaderOffset)
    }
  }, [])

  return (
    <div className="min-h-screen flex flex-col min-w-0 overflow-x-clip">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[400] focus:rounded-md focus:bg-white focus:p-3 focus:text-brand-cherry">Skip to content</a>
      {/* FIX: Added 'sticky', 'top-0', and 'z-[100]'. 
         This keeps the header above the Outlet and offer bars.
      */}
      <div ref={headerRef} className='lg:sticky lg:top-0 z-[100] bg-white' data-app-header>
        <HeaderTop onOpenCategories={() => setMobileCategoriesOpen(true)} />
        <CategoryNav
          mobileOpen={mobileCategoriesOpen}
          setMobileOpen={setMobileCategoriesOpen}
          showMobileHeader={false}
        />
      </div>

      {/* Added z-0 to main to ensure it stays in the background */}
      <main id="main-content" tabIndex={-1} className='container mx-auto flex-1 w-full min-w-0 relative z-0 pb-24 md:pb-0 outline-none'>  
        <Outlet />
      </main>
      
      <MobileBottomBar />
      <BackToTopButton />
      <Footer />
    </div>
  )
}
export default Layout
